export default __webpack_public_path__ + "static/media/Nandhini-FullStackDeveloper.40fb1e3b.pdf";